/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
import "./earnRewardItem.scss";
import RewardIcon from "../assets/invite-reward.svg";
import { useTranslation } from "@/i18n/client";

interface ItemProp {
  inviterNum?: number;
  inviterTxt?: string;
  currency?: string;
  awardTxt?: string;
  activityData?: any;
}

interface RewardItemProp {
  num: number;
  desc: string;
  showLine?: boolean;
}

export function YourRewardItem({ num, desc, showLine = true }: RewardItemProp) {
  return (
    <div className="reward_item">
      <div className="reward_num">{num}</div>
      <div className="reward_desc">{desc}</div>
      {showLine && <div className="reward_line" />}
    </div>
  );
}

export function EarnRewardLeftItem({ inviterNum, inviterTxt, currency, awardTxt }: ItemProp) {
  const { t } = useTranslation()
  return (
    <div className="reward_flex">
      <RewardIcon />
      <span>
        {t("profile.inviteFriend.rewardLeftTxt", { inviterNum, inviterTxt, currency, awardTxt })}
      </span>
    </div>
  );
}

export function EarnRewardRightItem({ currency, awardTxt }: ItemProp) {
  const { t } = useTranslation()
  return (
    <div className="reward_flex">
      <RewardIcon />
      <span>
        {t("profile.inviteFriend.rewardRightTxt", { currency, awardTxt })}
      </span>
    </div>
  );
}

export function EarnRewardStep1Item() {
  const { t } = useTranslation()
  return (
    <div className="code_flex">
      <div className="title">{t("profile.inviteFriend.stepOne")}</div>
      <div className="content">{t("profile.inviteFriend.stepOneDesc")}</div>
    </div>
  );
}

export function EarnRewardStep2Item({ currency, activityData }: ItemProp) {
  const { t } = useTranslation()
  return (
    <div className="code_flex">
      <div className="title">{t("profile.inviteFriend.stepTwo")}</div>
      <div className="content">
        {t("profile.inviteFriend.stepTwoDesc", { discount: `${currency}${activityData?.invitedCoupon?.discount}` })}
      </div>
    </div>
  );
}

export function EarnRewardStep3Item({ currency, activityData }: ItemProp) {
  const { t } = useTranslation()
  return (
    <div className="code_flex">
      <div className="title">{t("profile.inviteFriend.stepThree")}</div>
      <div className="content">
        {t("profile.inviteFriend.stepThreeDesc", { discount: `${currency}${activityData?.inviterCoupon?.discount}` })}
      </div>
    </div>
  );
}
